import * as moment from "moment";
import * as React from "react";
import { Component } from "react";
import { Redirect } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import SimpleDualRateStatement from "src/components/projects/project/statements/simple/dualrate/SimpleDualRateStatement";
import StatementNavbar from "src/components/projects/project/statements/StatementNavbar";
import {
  findAllCriterionMatches,
  findFirstCriterionMatch,
  IPdfPage,
  ISearchResult,
} from "src/global";
import { IDefaultProps } from "src/interfaces";
import fs from "src/services/config/fbConfig";
import { ISimpleDualRateStatementPageState } from "./interfaces";

export default class SimpleDualRateStatementPage extends Component<
  IDefaultProps,
  ISimpleDualRateStatementPageState
> {
  private projectDocument: firebase.firestore.DocumentReference;
  private statementDocument: firebase.firestore.DocumentReference;
  private simpleStatementDocument: firebase.firestore.DocumentReference;
  public constructor(props: IDefaultProps) {
    super(props);

    this.state = {
      loading: true,
      needsSaving: false,
      statementDate: Date.now(),
      yearsWithSolar: 0,
      totalElectricityFromGrid: 0,
      onPeakElectricityFromGrid: 0,
      totalElectricityCredited: 0,
      onPeakElectricityCredited: 0,
      lastMonthOnPeakCredit: 0,
      lastMonthOffPeakCredit: 0,
      totalAmountDue: 0,
      solarGenerated: 0,
      serviceStartDate: Date.now(),
      serviceEndDate: Date.now(),
      allowStatementUpload: false,
      allowStatementParsing: false,
      file: null,
      filename: "",
      storagePath: "",
      uploaded: false,
      importing: false,
      priorDataEditable: false,
    };

    this.renderStatementNavbar = this.renderStatementNavbar.bind(this);
    this.handleTotalElectricityFromGrid = this.handleTotalElectricityFromGrid.bind(this);
    this.handleOnPeakElectricityFromGrid = this.handleOnPeakElectricityFromGrid.bind(this);
    this.handleTotalElectricityCredited = this.handleTotalElectricityCredited.bind(this);
    this.handleOnPeakElectricityCredited = this.handleOnPeakElectricityCredited.bind(this);
    this.handleLastMonthOnPeakCredit = this.handleLastMonthOnPeakCredit.bind(this);
    this.handleLastMonthOffPeakCredit = this.handleLastMonthOffPeakCredit.bind(this);
    this.handleStatementDateChanged = this.handleStatementDateChanged.bind(this);
    this.handleYearsWithSolarChanged = this.handleYearsWithSolarChanged.bind(this);
    this.handleTotalAmountDueChanged = this.handleTotalAmountDueChanged.bind(this);
    this.handleSolarGenerated = this.handleSolarGenerated.bind(this);
    this.handleServiceStartDate = this.handleServiceStartDate.bind(this);
    this.handleServiceEndDate = this.handleServiceEndDate.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.handleSaveAndClose = this.handleSaveAndClose.bind(this);

    this.handleFilenameChanged = this.handleFilenameChanged.bind(this);
    this.deleteUploadedStatement = this.deleteUploadedStatement.bind(this);
    this.setStoragePath = this.setStoragePath.bind(this);
    this.setUploadStatus = this.setUploadStatus.bind(this);
    this.importPDFData = this.importPDFData.bind(this);

    this.saveData = this.saveData.bind(this);
  }

  public componentWillMount() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.projectDocument = fs.fs.collection("projects").doc(projectId);
    this.statementDocument = this.projectDocument
      .collection("statements")
      .doc(this.props.match.params.id);
    this.simpleStatementDocument = this.projectDocument
      .collection("simpleDualRateStatements")
      .doc(this.statementDocument.id);
  }

  public componentDidMount() {
    this.projectDocument
      .get()
      .then(doc => {
        if (doc.exists) {
          const { allowStatementParsing, allowStatementUpload } = doc.data() as any;
          this.setState({
            allowStatementParsing: allowStatementParsing ? allowStatementParsing : false,
            allowStatementUpload: allowStatementUpload ? allowStatementUpload : false,
            priorDataEditable: false,
          });
        }
      })
      .then(() => {
        this.statementDocument
          .get()
          .then(doc => {
            if (doc.exists) {
              const {
                statementDate,
                yearsWithSolar,
                totalAmountDue,
                serviceStartDate,
                serviceEndDate,
                storagePath,
                filename,
                uploaded,
              } = doc.data() as any;
              this.setState({
                statementDate: statementDate ? statementDate : Date.now(),
                yearsWithSolar: yearsWithSolar ? yearsWithSolar : 0,
                totalAmountDue: totalAmountDue ? totalAmountDue : 0,
                serviceStartDate: serviceStartDate ? serviceStartDate : Date.now(),
                serviceEndDate: serviceEndDate ? serviceEndDate : Date.now(),
                storagePath: storagePath ? storagePath : "",
                filename: filename ? filename : "",
                uploaded: uploaded ? uploaded : false,
              });

              if (storagePath && storagePath !== "") {
                const storedFile = fs.fsStorage.ref().child(storagePath);
                storedFile
                  .getMetadata()
                  .then(metaData => {
                    const filename = metaData.customMetadata.filename;
                    this.setState({ filename, uploaded: true });
                  })
                  .catch(error => {
                    console.log(error);
                  });
              }
            }
          })
          .then(() => {
            this.simpleStatementDocument.get().then(doc => {
              if (doc.exists) {
                const {
                  totalElectricityFromGrid,
                  onPeakElectricityFromGrid,
                  totalElectricityCredited,
                  onPeakElectricityCredited,
                  lastMonthOnPeakCredit,
                  lastMonthOffPeakCredit,
                  solarGenerated,
                } = doc.data() as any;
                this.setState({
                  totalElectricityFromGrid: totalElectricityFromGrid ? totalElectricityFromGrid : 0,
                  onPeakElectricityFromGrid: onPeakElectricityFromGrid
                    ? onPeakElectricityFromGrid
                    : 0,
                  totalElectricityCredited: totalElectricityCredited ? totalElectricityCredited : 0,
                  onPeakElectricityCredited: onPeakElectricityCredited
                    ? onPeakElectricityCredited
                    : 0,
                  lastMonthOnPeakCredit: lastMonthOnPeakCredit ? lastMonthOnPeakCredit : 0,
                  lastMonthOffPeakCredit: lastMonthOffPeakCredit ? lastMonthOffPeakCredit : 0,
                  solarGenerated: solarGenerated ? solarGenerated : 0,
                });
              } else {
                this.simpleStatementDocument.set({
                  totalElectricityFromGrid: 0,
                  onPeakElectricityFromGrid: 0,
                  totalElectricityCredited: 0,
                  onPeakElectricityCredited: 0,
                  lastMonthOnPeakCredit: 0,
                  lastMonthOffPeakCredit: 0,
                  solarGenerated: 0,
                });
              }
            });
          })
          .then(() => {
            this.setState({ loading: false });
          });
      });
  }

  public render() {
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }

    if (this.state.importing) {
      return <LoadingStatus text="Importing Statement Data..." />;
    }

    return (
      <div className="container-fixed-navbar">
        {this.renderStatementNavbar()}
        <SimpleDualRateStatement
          appService={this.props.appService}
          match={this.props.match}
          history={this.props.history}
          serviceStartDate={this.state.serviceStartDate}
          serviceEndDate={this.state.serviceEndDate}
          handleServiceStartDate={this.handleServiceStartDate}
          handleServiceEndDate={this.handleServiceEndDate}
          statementDate={this.state.statementDate}
          yearsWithSolar={this.state.yearsWithSolar}
          totalAmountDue={this.state.totalAmountDue}
          solarGenerated={this.state.solarGenerated}
          handleStatementDate={this.handleStatementDateChanged}
          handleYearsWithSolar={this.handleYearsWithSolarChanged}
          handleTotalAmountDue={this.handleTotalAmountDueChanged}
          totalElectricityFromGrid={this.state.totalElectricityFromGrid}
          onPeakElectricityFromGrid={this.state.onPeakElectricityFromGrid}
          totalElectricityCredited={this.state.totalElectricityCredited}
          lastMonthOnPeakCredit={this.state.lastMonthOnPeakCredit}
          lastMonthOffPeakCredit={this.state.lastMonthOffPeakCredit}
          onPeakElectricityCredited={this.state.onPeakElectricityCredited}
          handleTotalElectricityFromGrid={this.handleTotalElectricityFromGrid}
          handleOnPeakElectricityFromGrid={this.handleOnPeakElectricityFromGrid}
          handleTotalElectricityCredited={this.handleTotalElectricityCredited}
          handleOnPeakElectricityCredited={this.handleOnPeakElectricityCredited}
          handleLastMonthOnPeakCredit={this.handleLastMonthOnPeakCredit}
          handleLastMonthOffPeakCredit={this.handleLastMonthOffPeakCredit}
          handleSolarGenerated={this.handleSolarGenerated}
        />
      </div>
    );
  }

  private renderStatementNavbar() {
    const brand = this.props.appService.getActiveProjectLocation();
    return (
      <StatementNavbar
        appService={this.props.appService}
        match={this.props.match}
        history={this.props.history}
        isAdvanced={false}
        allowStatementParsing={this.state.allowStatementParsing}
        allowStatementUpload={this.state.allowStatementUpload}
        brand={brand}
        file={this.state.file}
        filename={this.state.filename}
        handleFilenameChanged={this.handleFilenameChanged}
        importPDFData={this.importPDFData}
        setStoragePath={this.setStoragePath}
        needsSaving={this.state.needsSaving}
        storagePath={this.state.storagePath}
        saveData={this.saveData}
        deleteUploadedStatement={this.deleteUploadedStatement}
        setUploadStatus={this.setUploadStatus}
        uploaded={this.state.uploaded}
        priorDataEditable={this.state.priorDataEditable}
      />
    );
  }

  private handleTotalElectricityFromGrid(value: any) {
    this.setState({
      totalElectricityFromGrid: Number(value),
      needsSaving: true,
    });
  }
  private handleOnPeakElectricityFromGrid(value: any) {
    this.setState({
      onPeakElectricityFromGrid: Number(value),
      needsSaving: true,
    });
  }
  private handleTotalElectricityCredited(value: any) {
    this.setState({
      totalElectricityCredited: Number(value),
      needsSaving: true,
    });
  }
  private handleOnPeakElectricityCredited(value: any) {
    this.setState({
      onPeakElectricityCredited: Number(value),
      needsSaving: true,
    });
  }
  private handleLastMonthOnPeakCredit(value: any) {
    this.setState({
      lastMonthOnPeakCredit: Number(value),
      needsSaving: true,
    });
  }
  private handleLastMonthOffPeakCredit(value: any) {
    this.setState({
      lastMonthOffPeakCredit: Number(value),
      needsSaving: true,
    });
  }
  private handleSolarGenerated(value: any) {
    this.setState({
      solarGenerated: Number(value),
      needsSaving: true,
    });
  }
  private handleStatementDateChanged(value: any) {
    if (!value) {
      return;
    }
    const date = new Date(value).valueOf();
    this.setState({ statementDate: date, needsSaving: true });
  }
  private handleServiceStartDate(value: any) {
    if (!value) {
      return;
    }
    const date = new Date(value).valueOf();
    this.setState({ serviceStartDate: date, needsSaving: true });
  }
  private handleServiceEndDate(value: any) {
    if (!value) {
      return;
    }
    const date = new Date(value).valueOf();
    this.setState({ serviceEndDate: date, needsSaving: true });
  }
  private handleYearsWithSolarChanged(value: any) {
    this.setState({ yearsWithSolar: value, needsSaving: true });
  }
  private handleTotalAmountDueChanged(value: any) {
    this.setState({ totalAmountDue: value, needsSaving: true });
  }
  private handleSave(e: any) {
    e.preventDefault();
    this.saveData(this.state.needsSaving);
  }
  private saveData(needsSaving: boolean) {
    if (needsSaving) {
      this.setState({ loading: true });
      this.simpleStatementDocument
        .update({
          totalElectricityFromGrid: Number(this.state.totalElectricityFromGrid),
          onPeakElectricityFromGrid: Number(this.state.onPeakElectricityFromGrid),
          totalElectricityCredited: Number(this.state.totalElectricityCredited),
          onPeakElectricityCredited: Number(this.state.onPeakElectricityCredited),
          lastMonthOnPeakCredit: Number(this.state.lastMonthOnPeakCredit),
          lastMonthOffPeakCredit: Number(this.state.lastMonthOffPeakCredit),
          solarGenerated: Number(this.state.solarGenerated),
        })
        .then(() => {
          this.statementDocument
            .update({
              statementDate: Number(this.state.statementDate),
              yearsWithSolar: Number(this.state.yearsWithSolar),
              totalAmountDue: Number(this.state.totalAmountDue),
              serviceStartDate: Number(this.state.serviceStartDate),
              serviceEndDate: Number(this.state.serviceEndDate),
              storagePath: this.state.storagePath,
              filename: this.state.filename,
              uploaded: this.state.uploaded,
            })
            .then(() => {
              this.setState({ loading: false, needsSaving: false });
            });
        });
    }
  }

  private handleSaveAndClose(e: any) {
    e.preventDefault();
    this.saveData(this.state.needsSaving);
    this.props.history.push(`/project/${this.props.appService.getActiveProjectId()}`);
  }

  private handleFilenameChanged(e: any) {
    const files: FileList = e.target.files;
    if (files) {
      const file: File = files[0];
      if (file) {
        this.setState({ file, filename: file.name });
      }
    }
  }

  private deleteUploadedStatement() {
    this.setState({
      file: null,
      filename: "",
      storagePath: "",
      uploaded: false,
    });
    this.saveData(true);
  }

  private importPDFData(pdfPages: IPdfPage[], importType: number): void {
    this.setState({ importing: true });
    setTimeout(() => {
      const statementDateFormat: string = "MMMM DD, YYYY";

      let totalAmountDue = 0.0;
      let statementDate = Date.now();
      let totalElectricityFromGrid = 0.0;
      let onPeakElectricityFromGrid = 0.0;
      let totalElectricityCredited = 0.0;
      let onPeakElectricityCredited = 0.0;
      let lastMonthOnPeakCredit = 0.0;
      let lastMonthOffPeakCredit = 0.0;
      let serviceEndDate = Date.now();
      let serviceStartDate = Date.now();

      let searchResult: ISearchResult = findFirstCriterionMatch(
        pdfPages,
        "Total charges for electricity services",
        true,
        false
      );
      if (searchResult.found) {
        if (searchResult.result.startsWith("$")) {
          const sTotalAmountDue = searchResult.result;
          totalAmountDue = Number(sTotalAmountDue.substring(1, sTotalAmountDue.length));
        } else {
          totalAmountDue = Number(searchResult.result);
        }
      }

      let allSearchResults = findAllCriterionMatches(pdfPages, "Your electricity bill", true, true);
      if (allSearchResults.length > 0) {
        allSearchResults.forEach(result => {
          if (result.result.startsWith("Bill date:")) {
            const res = result.result as string;
            const sStatementDate = res.substring(11);
            if (moment(sStatementDate, statementDateFormat).isValid()) {
              statementDate = moment(sStatementDate, statementDateFormat).valueOf();
            }
          }
        });
      }

      searchResult = findFirstCriterionMatch(pdfPages, "Meter reading on", false, false);
      if (searchResult.found) {
        const readDate = (searchResult.result as string).substring(17) + ", " + moment().year();
        serviceEndDate = moment(readDate, "MMM DD YYYY").valueOf();
      }

      allSearchResults = findAllCriterionMatches(pdfPages, "Meter reading on", false, false);
      if (allSearchResults.length === 4) {
        // First 2 are grid readings.  Second 2 are solar credit readings.  Index 1 is last month grid reading.
        const readDate =
          (allSearchResults[1].result as string).substring(17) + ", " + moment().year();
        serviceStartDate = moment(readDate, "MMM DD YYYY").valueOf();
      }

      searchResult = findFirstCriterionMatch(
        pdfPages,
        "Total electricity from APS, in kWh",
        true,
        true
      );
      if (searchResult.found) {
        totalElectricityFromGrid = Number(searchResult.result);
      }

      searchResult = findFirstCriterionMatch(
        pdfPages,
        "On-peak electricity from APS, in kWh",
        true,
        true
      );
      if (searchResult.found) {
        onPeakElectricityFromGrid = Number(searchResult.result);
      }

      searchResult = findFirstCriterionMatch(
        pdfPages,
        "Total electricity credited, in kWh",
        true,
        true
      );
      if (searchResult.found) {
        totalElectricityCredited = Number(searchResult.result);
      }

      searchResult = findFirstCriterionMatch(
        pdfPages,
        "On-peak electricity credited, in kWh",
        true,
        true
      );
      if (searchResult.found) {
        onPeakElectricityCredited = Number(searchResult.result);
      }

      searchResult = findFirstCriterionMatch(
        pdfPages,
        "Last month's on-peak kWh credit",
        true,
        true
      );
      if (searchResult.found) {
        lastMonthOnPeakCredit = Number(searchResult.result);
      }

      searchResult = findFirstCriterionMatch(
        pdfPages,
        "Last month's off-peak kWh credit",
        true,
        true
      );
      if (searchResult.found) {
        lastMonthOffPeakCredit = Number(searchResult.result);
      }

      this.setState({
        statementDate,
        serviceStartDate,
        serviceEndDate,
        totalAmountDue,
        totalElectricityFromGrid,
        onPeakElectricityFromGrid,
        totalElectricityCredited,
        onPeakElectricityCredited,
        lastMonthOnPeakCredit,
        lastMonthOffPeakCredit,
        importing: false,
        needsSaving: true,
      });
    }, 1000);
  }

  private setStoragePath(storagePath: string, filename: string): void {
    this.setState({ storagePath, filename });
  }

  private setUploadStatus(uploaded: boolean): void {
    this.setState({ uploaded: true, needsSaving: true });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/statements/simple/dualrate/SimpleDualRateStatementPage.tsx